import { Badge } from '@mantine/core'
import type { AuditAccessSource, AuditChangeSource } from '@behuman/core-contract'
import { ACCESS_SOURCE_LABELS, CHANGE_SOURCE_LABELS } from './auditModel'

// S21 — the integration family shares the mockup's orange so a reader still parses
// "external" at a glance, while the label says which network it was.
const ACCESS_SOURCE_COLORS: Record<AuditAccessSource, string> = {
  'behuman-web': 'teal',
  'ai-service': 'indigo',
  api: 'gray',
  tefca: 'orange',
  'health-gorilla': 'orange',
  erx: 'orange',
  'other-integration': 'orange',
  // S28 — blue, not orange: an ingested event is not an external exchange, it is a FHIR
  // interaction we learned about from Medplum's own log rather than from the client.
  'medplum-audit': 'blue',
  integration: 'orange',
}

const CHANGE_SOURCE_COLORS: Record<AuditChangeSource, string> = {
  manual: 'gray',
  ai: 'indigo',
  integration: 'orange',
}

export function AccessSourceBadge({ source }: { source: AuditAccessSource }) {
  return (
    <Badge
      size="sm"
      variant="light"
      color={ACCESS_SOURCE_COLORS[source]}
      styles={{ root: { textTransform: 'none', fontWeight: 500 } }}
    >
      {ACCESS_SOURCE_LABELS[source]}
    </Badge>
  )
}

export function ChangeSourceBadge({ source }: { source: AuditChangeSource }) {
  return (
    <Badge
      size="sm"
      variant="light"
      color={CHANGE_SOURCE_COLORS[source]}
      styles={{ root: { textTransform: 'none', fontWeight: 500 } }}
    >
      {CHANGE_SOURCE_LABELS[source]}
    </Badge>
  )
}

/** Initials avatar matching the mockup row leading circle. */
export function ActorAvatar({ name }: { name: string }) {
  const initials = name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join('')
  return (
    <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-gray-100 text-xs font-semibold text-gray-600">
      {initials || '?'}
    </div>
  )
}
